import { render, staticRenderFns } from "./CoinChart.vue?vue&type=template&id=0f45e471&scoped=true"
import script from "./CoinChart.vue?vue&type=script&lang=js"
export * from "./CoinChart.vue?vue&type=script&lang=js"
import style0 from "./CoinChart.vue?vue&type=style&index=0&id=0f45e471&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f45e471",
  null
  
)

export default component.exports